import { type HTMLAttributes, type ReactNode } from 'react';

type BadgeVariant = 'growth' | 'stress' | 'calm' | 'muted';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  live?: boolean;
  children: ReactNode;
}

export function Badge({
  variant = 'muted',
  live = false,
  children,
  className = '',
  ...props
}: BadgeProps) {
  const variantClass = `badge-${variant}`;
  const liveClass = live ? 'badge-live' : '';

  return (
    <span
      className={`badge ${variantClass} ${liveClass} ${className}`.trim()}
      {...props}
    >
      {children}
    </span>
  );
}
